import * as React from 'react';
import { Link } from 'react-router-dom';
import { IconButton, Typography } from '@material-ui/core';

import './Navigation.scss';
import Query from 'react-apollo/Query';
import gql from 'graphql-tag';
import * as jwt from 'jsonwebtoken';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';

// tslint:disable-next-line:no-empty-interface
export interface INavigationProps {
  customer?: string,
  economicGroups?: any[],
  icon?: React.ReactElement<any>,
  name: string,
  linkDefault: string,
  link: string,
  linkTitle: string,
  painel: number, // 1 - editoras 2 - livrarias 3 - distribuidoras
}
import Button from '@material-ui/core/Button';
import InfoOutlineIcon from '@material-ui/icons/InfoOutline';
// tslint:disable-next-line:no-empty-interface
export interface INavigationState {
  id: string;
  openSeeStoresDialig: boolean;
}

const PUBLISHER_LOGO_PUBLISHERS = gql`
  query publisherLogo {
    publisherLogo {
      path
    }
  }
`;
const PUBLISHER_LOGO_BOOKSTORE = gql`
  query bookstoreLogo {
    bookstoreLogo {
      path
    }
  }
`;

const GET_LOGGED_USER = gql`
query user {
  user {
    email,
    full_name
  }
}
`;

export class Navigation extends React.Component<INavigationProps, INavigationState> {
  constructor(props: INavigationProps) {
    super(props);
    const token = JSON.parse(JSON.stringify(jwt.decode('' + sessionStorage.getItem('token'))));
    this.state = {
      id: token === undefined || token === null ? '' : token.username,
      openSeeStoresDialig: false
    }
    this.handleClickSeeStores = this.handleClickSeeStores.bind(this);
    this.handleCloseSeeStores = this.handleCloseSeeStores.bind(this);
  }

  public render() {
    const jsonFilter = {
      "id": this.state.id
    };

    if(this.props.painel === 0) {
      return (
          <div className="navigation-panel" >
            <div className="navigation-customer">
              <div className="user-information user-information-heigth">
                <Query query={GET_LOGGED_USER}>
                  {({ data:userData }) => {
                    if (userData && userData.user) {
                      return (
                        <Typography component="h6" className="user-header">
                          Olá, {userData.user.full_name}!
                        </Typography>
                      );
                    } else {
                      return null;
                    }
                  }}
                </Query>
              </div>
            </div>
          </div>
      );
    } else if (this.props.painel === 1){
      return (
        <div >
          <div className="navigation-panel" >
            <div className="navigation-customer">
              <Query query={PUBLISHER_LOGO_PUBLISHERS} variables={jsonFilter}>
                {({ loading, error, data, client: cliente}) => {
                  // tslint:disable-next-line:no-debugger
                  return (
                    <div className="user-information information-width">
                      {/* <Link to={this.props.linkDefault} className="navigation-link-default">
                        {loading && <LinearProgress />}
                        {
                          data && data.publisherLogo &&
                          (<img src={data.publisherLogo.path} className="navigation-logo" />)
                        }
                      </Link> */}
                      <Query query={GET_LOGGED_USER}>
                        {({ data:userData }) => {
                          if (userData && userData.user) {
                            return (
                              <Typography component="h6" className="user-header">
                                Olá, {userData.user.full_name}!
                              </Typography>
                            );
                          } else {
                            return null;
                          }
                        }}
                      </Query>
                    </div>
                  )
                }}
              </Query>
              <Typography className="navigation-name" variant="title">
                {this.props.name}
              </Typography>
              <Link to={this.props.link} className="navigation-link information-width">
                <span className="navigation-link-title" >{this.props.linkTitle}</span>
                <IconButton className="navigation-icon">
                  {this.props.icon}
                </IconButton>
              </Link>
            </div>
          </div>
        </div>
      );
    } else if (this.props.painel === 2){
      return (
        <div className="user-information" >
          <div className="navigation-panel" >
            <div className="navigation-customer">
            <Query query={PUBLISHER_LOGO_BOOKSTORE} variables={jsonFilter}>
              {({ loading, error, data, client: cliente}) => { 
                return (
                  <div className="user-information information-width">
                    {/* <Link to={this.props.linkDefault} className="navigation-link-default">
                      {loading ? <LinearProgress /> : <img src={data !== undefined && data.bookstoreLogo !== undefined ? data.bookstoreLogo.path : ''} className="navigation-logo" />}
                    </Link> */}
                    <Query query={GET_LOGGED_USER}>
                      {({ data:userData }) => {
                        if (userData && userData.user) {
                          return (
                            <Typography component="h6" className="user-header">
                              Olá, {userData.user.full_name}!
                            </Typography>
                          );
                        } else {
                          return null;
                        }
                      }}
                    </Query>
                  </div>
                )
              }}
              </Query>
              <Typography className="navigation-name" variant="title">
                {this.props.name}
              </Typography>
              <Link to={this.props.link} className="navigation-link information-width">
                <span className="navigation-link-title" >{this.props.linkTitle}</span>
                <IconButton className="navigation-icon">
                  {this.props.icon}
                </IconButton>
              </Link>
            </div>
          </div>
        </div>
      );
    }
    else {
      const {economicGroups} = this.props;
      return (
        <div className="user-information" >
          <div className="navigation-panel" >
            <div className="navigation-customer">
              <div className="user-information">
                <Query query={GET_LOGGED_USER}>
                  {({ data:userData }) => {
                    if (userData && userData.user) {
                      return (
                        <Typography component="h6" className="user-header">
                          Olá, {userData.user.full_name}!
                        </Typography>
                      );
                    } else {
                      return null;
                    }
                  }}
                </Query>
              </div>
              <Typography className="navigation-name" variant="title">
                {this.props.name}
              </Typography>
              {economicGroups != null 
                && economicGroups !== undefined 
                && economicGroups.length > 0 && 
                  <div>
                    <Button variant="outlined" color="primary" className="see-stores" onClick={this.handleClickSeeStores}>
                        <InfoOutlineIcon />
                        Lojas que compõem a análise
                    </Button>
                  
                    { economicGroups != null && economicGroups !== undefined && 
                      <Dialog
                          open={this.state.openSeeStoresDialig}
                          onClose={this.handleCloseSeeStores}
                          aria-labelledby="alert-dialog-title"
                          aria-describedby="alert-dialog-description"
                      >
                          <DialogTitle>{"Lojas que compõem a análise"}</DialogTitle>
                          <DialogContent>
                              <DialogContentText id="alert-dialog-description">
                                  <List className="stores-list" subheader={<li />}>
                                      { economicGroups!== undefined && economicGroups.map((group: any) => (
                                          <li key={`section-${group.id}`}>
                                              <ul>
                                                  <ListSubheader className="group-name">{ group.grupo}</ListSubheader>
                                                  {group.stores.map((store: any) => (
                                                      <ListItem key={`item-${group.id}-${store.name}`} className="store-name">
                                                          <ListItemText primary={`${store.name} - ${store.state}`} />
                                                      </ListItem>
                                                  ))}
                                              </ul>
                                          </li>
                                      ))}
                                  </List>
                              </DialogContentText>
                          </DialogContent>
                      </Dialog>
                    }
                  </div>
              }
              {(economicGroups == null 
                || economicGroups === undefined 
                || economicGroups.length === 0) &&
                <Link to="#" className="navigation-link">
                  <span className="navigation-link-title" />
                </Link>
              }
            </div>
          </div>
        </div>
      );
    };

  }

  public handleClickSeeStores() {
    this.setState({ openSeeStoresDialig: true });
  }

  public handleCloseSeeStores () {
      this.setState({ openSeeStoresDialig: false });
  }
}



// WEBPACK FOOTER //
// ./src/component/shared/layout/navigation/Navigation.tsx